"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageService = void 0;
var _stringToBool = require("./stringToBool");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LocalStorageService = exports.LocalStorageService = /*#__PURE__*/function () {
  function LocalStorageService() {
    _classCallCheck(this, LocalStorageService);
  }
  return _createClass(LocalStorageService, [{
    key: "getAll",
    value: function getAll(prefix) {
      var config = {};

      //ensure its correct type.
      Object.keys(localStorage).forEach(function (a) {
        var cleaned = a.replace(prefix, "");
        if (localStorage[a] && ["sound", "fastPlay", "autoAdjustBet", "vibrate", "blitzStopOnFeature", "splashScreenHide", "blitzSplashScreenHide", "spaceToSpin", "hideCurrencySign"].indexOf(cleaned) > -1) {
          config[cleaned] = (0, _stringToBool.stringToBool)(localStorage[a]);
        }
      });
      return config;
    }
  }, {
    key: "get",
    value: function get(prefix, name) {
      return localStorage.getItem(prefix + name);
    }
  }, {
    key: "set",
    value: function set(prefix, name, value, attr) {
      localStorage.setItem(prefix + name, value);
    }
  }, {
    key: "remove",
    value: function remove(prefix, name) {
      localStorage.removeItem(prefix + name);
    }
  }]);
}();
//# sourceMappingURL=localStorageService.js.map